import { createContext } from 'react';
import type { Repositories } from './RepositoryInterfaces.js';

export const RepositoryContext = createContext<Repositories | null>(null);
